import {inject} from '@angular/core'
import {ConfigService} from '../services/config.service'
import {Router} from '@angular/router'
import {LOGIN_PATH} from '../0-general/shared'

export const authGuard = (): boolean | Promise<boolean> => {
  const router = inject(Router)
  const configService = inject(ConfigService)
  if (configService.accessTokenValid()) {
    return true
  }
  return router.navigate(['/', LOGIN_PATH]).then(() => false)
}
